import React from "react";
import "./Hero.css";
import hero_background from "../../assets/hero_background.jpg";

const Hero = () => {
  return (
    <div className="hero container">
      <h1>Welcome to G Automative</h1>
      <p>
        Welcome to G Automative, your premier destination for all things
        automotive.
        <br className="mobile-hide" />
        Whether you're looking for expert advice, the latest news, or
        top-quality products, we have everything you need
        <br className="mobile-hide" />
        to keep your vehicle in peak condition. Explore our comprehensive range
        of services and resources designed to meet all your
        <br className="mobile-hide" />
        automotive needs. Join our community and drive with confidence knowing
        you're backed by the best in the industry.
        <br className="mobile-hide" />
        Discover how our innovative solutions can elevate your automotive
        experience and help you stay ahead of the curve.
      </p>

      <button>Contact Us</button>
    </div>
  );
};

export default Hero;
